module.exports = __webpack_public_path__ + "img/SOLITA_BLACK_HOR_RGB.c559135d.png";